import React from 'react'
import { Box, Typography, Avatar } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'

const ProjectManager = ({ name, avatar }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Avatar sx={{ width: 25, height: 25, bgcolor: '#DAA520', fontSize: '0.75rem', p: avatar ? 0 : 0.5 }}>
          {avatar ? (
            <img
              src={avatar}
              alt={name}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                display: 'block',
                borderRadius: '50%',
              }}
            />
          ) : (
            name?.charAt(0) || <PersonIcon sx={{ fontSize: 14, fontWeight: 500 }} />
          )}
        </Avatar>
        <Typography variant="body2" fontWeight={600} sx={{ fontSize: '14px', fontWeight: 600 }}>
          {name}
        </Typography>
      </Box>
    </Box>
  )
}

export default ProjectManager